<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" *ngIf="movementOrderDetails">
  <sc-dialog-title>{{'Rangieren über Wartezone' |
    translate:['tmc-yard.widgets.movement-orders.moving-order-rerouting-dialog.title',
    translationService.language]}}</sc-dialog-title>
  <sc-separator-line></sc-separator-line>
  <div class="hint">
    {{"no capacity at target station" | translate:
    ["tmc-yard.widgets.movement-orders.moving-order-rerouting-dialog.description", translationService.language]}}
  </div>
  <sc-flex-fitting-content [vertical]="true">
    <app-structure-selection [context]="structureSelectionContext"></app-structure-selection>
  </sc-flex-fitting-content>
  <sc-separator-line></sc-separator-line>
  <sc-padding>
    <sc-flex>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button (click)="cancelDialog()">{{'Cancel' |
        translate:['tmc-yard.widgets.sac-client.moving-order-dialog.action.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button [disabled]="!confirmDialogEnabled" (click)="confirmDialog()">
        {{'Abruf erstellen' |
        translate:['tmc-yard.widgets.movement-orders.moving-order-rerouting-dialog.action.accept-movement-order',
        translationService.language]}}
      </button>
    </sc-flex>
  </sc-padding>
</sc-flex>
